'use strict';

module.exports = function(Department, dialog, forms, $state, teams, items) {
    var _this = this;
    this.items = items;
    this.form = forms.filter(function(form) {
        return form.id === $state.params.formId;
    })[0];


    _this.teams = teams.map(function(team) {
        var isSub = team.subscribedTo.filter(function(teamForm) {
            return teamForm.id === $state.params.formId;
        });

        if (isSub.length) {
            team.status = true;
        } else {
            team.status = false;
        }
        return team;
    });

    this.editForm = function() {
        $state.go('dashboard.departments.department.forms.form.builder');
    };

    this.subscriptionHandler = function(itemId, status) {
        if (status) {
            Department.addTeam({
                    departmentId: $state.params.departmentId,
                    formId: $state.params.formId,
                    teamId: itemId
                }, {})
                .$promise
                .then(function() {
                    _this.form.teams.push({
                        id: itemId
                    })

                })
                .catch(function(error) {
                    console.log(error);
                });
        } else {
            Department.removeTeam({
                    departmentId: $state.params.departmentId,
                    formId: $state.params.formId,
                    teamId: itemId
                }, {})
                .$promise
                .then(function() {
                    _this.form.teams = _this.form.teams.filter(function(team) {
                        return team.id !== itemId;
                    });
                    return;

                })
                .catch(function(error) {
                    console.log(error);
                });
        }
    };

    this.deleteForm = function() {
        dialog.confirm({
            title: 'Eliminar formulario',
            body: 'Al eliminar el formulario no tendra más acceso a los datos generados por el mismo.',
            accept: 'Eliminar formulario',
            cancel: 'Cancelar',
            size: 'sm'
        }).then(function() {
            Department.forms.destroyById({
                    id: $state.params.departmentId,
                    fk: $state.params.formId
                })
                .$promise.then(function() {
                    $state.reload('dashboard.departments.department.forms', {
                            departmentId: $state.params.departmentId
                        })
                        .then(function() {
                            $state.go('dashboard.departments.department.forms', {
                                departmentId: $state.params.departmentId
                            });
                        });
                })
                .catch(function(error) {
                    console.log(error);
                });
        });
    };
};
